import * as React from 'react';
import './success.scss';

const Success = ({ successText, successId }: { successText: string; successId?: string }) => {
  const successProps = successId ? { id: successId } : {};
  return (
    <span className="Success">
      <span className="Success-text" {...successProps}>
        {successText}
      </span>
    </span>
  );
};

export default Success;
